import api from "app/api";
import { Options } from "common";
import { ProgramItem } from "features/programs/programApi";
export interface ProgramVariantItem {
  id: number;
  name: string;
  display_name: string;
  program_id: number;
  program?: ProgramItem;
  code: string;
  compatibility_code?: string | null;
  sku: string;
  kitchen_group: string;
  min_unit: number;
  upgradable: boolean;
  window: boolean;
  active: boolean;
}

export type ProgramVariantOptions = Options<"program_id">;

export function getProgramVariantService(scope?: any) {
  return api.getService<
    ProgramVariantItem,
    ProgramVariantItem,
    ProgramVariantOptions
  >("program-variants", {
    scope,
    //params goes here
  });
}
